/**
 * Created by mukund on 8/25/17.
 *
 * This directive renders a single asset within the LMS Text Editor UI
 */
angular.module('mediacloudApp')
    .directive('lmsEmbedAsset', ['$timeout', function($timeout){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/lms/directives/asset/asset.html',
            scope: {
                asset: '=',
                multiSelect: '=multiselect',
                selectedAssets: '=',
                showAllAssets: '&'
            },
            link: function(scope, element, attrs){
                scope.toggleAssetSelect = function(){

                    scope.asset.selected = !scope.asset.selected;

                    if(scope.asset.selected) {

                        if(!scope.multiSelect) {
                            // Deselect all selected assets
                            scope.selectedAssets.map(function (a) {
                                a.selected = false;
                            });
                            // Remove all assets from the selectedAssets array
                            scope.selectedAssets.length = 0;
                        }

                        scope.selectedAssets.push(scope.asset);
                    } else {
                        var index = scope.selectedAssets.map(function(e) { return e.xid; }).indexOf(scope.asset.xid);
                        if(index > -1) {
                            scope.selectedAssets.splice(index, 1);
                        }
                        if(scope.selectedAssets.length === 0){
                            scope.showAllAssets({flag: true});
                        }
                    }
                };

                scope.$watch('asset', function(){
                    if(scope.asset){
                        $timeout(function(){
                            var assetTitleElement = element.find('.title');
                            scope.asset.tooltipState = assetTitleElement[0] && (assetTitleElement[0].scrollWidth - assetTitleElement.innerWidth() > 4);
                            
                            assetTitleElement.hover(function(){
                                scope.asset.tooltipState = assetTitleElement[0] && (assetTitleElement[0].scrollWidth - assetTitleElement.innerWidth() > 4);
                                scope.$apply();
                            });
                        })
                    }
                });
            }
        }

    }]);
